import React, { useMemo } from 'react';

import { get } from 'lodash';

import { Column } from '../../../modules/table';
import { TransactionHistorySearch } from '../../../services/api/dto/Transactions';
import { DOCUMENT_TYPE } from '../../../types';

import './index.scss';

const styleMap: Record<string, any> = {
  agent: 'agent',
  document: 'document',
  createdDate: 'createdDate',
};

interface IProps {
  rowData: TransactionHistorySearch;
  columns: Column<TransactionHistorySearch>[];
  onRowClick: (params: { id: number; type: DOCUMENT_TYPE }) => void;
}

const RowComponent: React.FC<IProps> = ({ rowData, columns, onRowClick }) => {
  const id = useMemo(() => {
    return get(rowData, 'originalOperationId', rowData.id);
  }, [rowData]);

  const type = useMemo(() => {
    return (rowData as any).documentType as DOCUMENT_TYPE;
  }, [rowData]);

  return (
    <div
      className="documents-item"
      onClick={() =>
        onRowClick({
          id,
          type,
        })
      }
    >
      {columns.map((column) => {
        const columnData = column.dataGetter(rowData) || '';
        return (
          <div
            className={`documents-item__${styleMap[column.name]}`}
            style={{ ...column.headerStyle }}
          >
            {column.Component ? (
              <column.Component data={columnData} status={rowData.status} />
            ) : (
              columnData
            )}
          </div>
        );
      })}
    </div>
  );
};

export default RowComponent;
